import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Centralized GSAP Plugin Registration
if (typeof window !== 'undefined') {
  gsap.registerPlugin(ScrollTrigger);
}

/**
 * Checks whether user prefers reduced motion.
 * @returns {boolean}
 */
export const prefersReducedMotion = () => {
  if (typeof window === 'undefined') return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
};

/**
 * Helper to safely configure ScrollTrigger animations respecting reduced motion.
 * @param {object} config GSAP animation config
 * @returns {gsap.core.Tween|gsap.core.Timeline}
 */
export const createScrollAnimation = (target, vars) => {
  if (prefersReducedMotion()) {
    // If reduced motion is preferred, apply final state immediately without scroll interpolation
    if (vars.to) {
      return gsap.set(target, vars.to);
    }
    return gsap.set(target, { opacity: 1, y: 0 });
  }

  return gsap.to(target, vars);
};

/**
 * Utility to refresh ScrollTrigger instances
 */
export const refreshScrollTrigger = () => {
  ScrollTrigger.refresh();
};

export { gsap, ScrollTrigger };
export default gsap;
